import { useMemo } from 'react';
import ChatMarkdown from '../markdownRenderers/ChatMarkdown';
import CodeBlock from '../markdownRenderers/CodeBlock';
import MarkdownTable from '../markdownRenderers/MarkdownTable';
import AnimatedElement from './AnimatedElement';

interface Props {
  text: string;
  fontSize?: string;
  fullWidthCode?: boolean;
}

const parseMessage = (message: string) =>
  message
    .replace(/<thinking>[\s\S]*?<\/thinking>/g, 'Done thinking!\n')
    .replace(/<thinking>[\s\S]*?$/g, 'Thinking...');

const TextMessageRenderer = ({ text, fullWidthCode }: Props) => {
  const components = useMemo(
    () => ({
      p: AnimatedElement,
      li: AnimatedElement,
      code: (props: any) => <CodeBlock {...props} fullWidth={fullWidthCode} />,
      a: (props: any) => (
        <a {...props} target="_blank" rel="noopener noreferrer" />
      ),
      table: MarkdownTable,
    }),
    [fullWidthCode],
  );

  return (
    <ChatMarkdown
      dir="auto"
      style={{ unicodeBidi: 'plaintext' }}
      components={components}
    >
      {parseMessage(text)}
    </ChatMarkdown>
  );
};

export default TextMessageRenderer;
